<template>
  <v-text-field 
    ref="autocompleteInput"
    :label="label"
    outlined
    dense
    hide-details
    v-model="address"
    autocomplete="new-password"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="false"
  ></v-text-field>
</template>

<script>
export default {
  name: "GoogleAddressInput",
  props: {
    label: { type: String, default: "Address" },
  },
  data() {
    return {
      address: "",
    };
  },
  mounted() {
    // attach Google Places Autocomplete
    const input = this.$refs.autocompleteInput.$el.querySelector("input");
    const autocomplete = new google.maps.places.Autocomplete(input, {
      types: ["geocode"],
    });

    
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      // console.log("Selected place:", place);

      let address = "",
        city = "",
        state = "",
        zip = "";

      if (place.address_components) {
        let street_number = "",
          route = "";
        for (const comp of place.address_components) {
          if (comp.types.includes("street_number"))
            street_number = comp.long_name;
          if (comp.types.includes("route")) route = comp.long_name;
          if (comp.types.includes("locality")) city = comp.short_name;
          if (comp.types.includes("sublocality")) city = comp.short_name;
          if (comp.types.includes("administrative_area_level_1"))
            state = comp.short_name;
          if (comp.types.includes("postal_code")) zip = comp.long_name;
        }
        address = `${street_number} ${route}`.trim();
      }

      this.$emit("address-selected", { address, city, state, zip });

      // Fill your v-model too
      // this.address = `${address}, ${city}, ${state} ${zip}`;
    });
  },
};
</script>
<style scoped>
.v-text-field input {
  font-size: 18px; /* bigger text */
  padding: 12px !important;
}
.google-autocomplete-container {
  margin-bottom: 16px; /* gives space around dropdown */
}

.v-text-field input {
  font-size: 18px;
  border-radius: 8px;
  padding: 14px !important;
}

.v-text-field .v-input__control {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
</style>